var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCircleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeWidth: 2,
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 20c0-4 16-4 16 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircleIcon);
export default __webpack_public_path__ + "static/media/user_circle_icon.5a0db836b7e69da601f4d23acc13f719.svg";
export { ForwardRef as ReactComponent };